import React from "react";

const Subscription = () => {
  return <div style={{display: "flex", width: "100%", height: "1000px", flexDirection: "column", backgroundColor: "white", overflow: "hidden"}}>
<iframe title="" width="100%" height="100%" src="https://app.termly.io/policy-viewer/policy.html?policyUUID=3b601652-3b2b-4887-8043-828edf93a462" /></div>;
};

export default Subscription;
